// Normalize phone number (remove formatting, keep digits only)
export function normalizePhone(phone) {
  if (!phone) return '';
  return phone.replace(/\D/g, ''); // Remove all non-digits
}

// Format phone number for display (XXX) XXX-XXXX
export function formatPhone(phone) {
  const digits = normalizePhone(phone);
  
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  
  return phone; // Return original if can't format
}

// Validate email format
export function isValidEmail(email) {
  if (!email) return false;
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

// Normalize customer name (trim, title case)
export function normalizeCustomerName(name) {
  if (!name) return '';
  
  return name
    .trim()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

// Check if two customers are potential duplicates
export function isPotentialDuplicate(customer1, customer2) {
  // Same normalized name
  const name1 = normalizeCustomerName(customer1.name || '');
  const name2 = normalizeCustomerName(customer2.name || '');
  
  if (name1 && name2 && name1 === name2) return true;
  
  // Same phone number
  const phone1 = normalizePhone(customer1.phone || customer1.phoneNumber || '');
  const phone2 = normalizePhone(customer2.phone || customer2.phoneNumber || '');
  
  if (phone1 && phone2 && phone1 === phone2) return true;
  
  // Same email (case insensitive)
  const email1 = (customer1.email || '').toLowerCase().trim();
  const email2 = (customer2.email || '').toLowerCase().trim();
  
  if (email1 && email2 && email1 === email2) return true;
  
  return false;
}

// Generate customer ID from name
export function generateCustomerId(name) {
  return normalizeCustomerName(name)
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
}